import { SUPPORTED_FORMATS } from "../../pages/appointment-details/common-pre-screen/common";
import DownloadImageApi from "../../services/downloadImageService"

export const handleDownload = async (id) => {
    try {
      const imgRes = await DownloadImageApi.getDownloadedImageul(id);
      const response = await fetch(imgRes?.data || "");

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response?.url;
    } catch (error) {
      // console.error("Download failed:", error);
      console.log("Download failed. Please try again later.");
    }
  };


export  const PaymentStatusList = [
    {name:'Lease on behalf',id:1,value:"1"},
    {name:'Incomplete',id:2,value:"2"},
    {name:'Complete',id:3,value:"3"},
  ]

export  const paymentModalData = {
            title: "Payment Status",
            children: [
                { type: "dropdown", name: "payment_status", label: "Payment Status", placeholder: "Select Payment Status", data: [], IsRequired: true },
                {
                      label: "Select Attachment",
                      type: "file",
                      name: "media_id",
                      multiple: true,
                      removeButton: false,
                      acceptFormat: SUPPORTED_FORMATS,
                      downloadFile: handleDownload,
                      placeholder: "Select a File",
                      required: false,
                      col: 1,
                },
                { type: "description", name: "remarks", label: "Remarks", placeholder: "Enter Remarks", IsRequired: true },
            ]
        }